class MinMaxCalculationResult {
    public MinimumsValid: boolean;
    // public MaximumsValid: boolean;
}

export { MinMaxCalculationResult };
